'use client';

import type { JSX } from 'react';
import { KaraokeBlock, loadUsageAudioCached } from '@/components/karaoke';

interface IKaraokeUsageNotesProps {
  slug: string;
  text: string;
  initialAudioUrl: string | null;
}

export function KaraokeUsageNotes({
  slug,
  text,
  initialAudioUrl,
}: IKaraokeUsageNotesProps): JSX.Element {
  return (
    <KaraokeBlock
      dir="ltr"
      initialAudioUrl={initialAudioUrl}
      label="Listen to usage notes"
      loadAudio={() => loadUsageAudioCached(slug)}
      showInlineIcon={false}
      text={text}
      textClassName="text-sm text-muted-foreground leading-relaxed"
    />
  );
}
